// Simple WebAudio alarm sounds (no asset needed).
let ctx = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

const SOUNDS = {
  chime: { notes: [660, 880, 1046], type: "sine" },
  bell: { notes: [988, 988, 1319], type: "triangle" },
  beep: { notes: [1046, 1046, 1046], type: "square" },
  soft: { notes: [523, 659, 784], type: "sine" },
};

export const ALARM_SOUNDS = ["chime", "bell", "beep", "soft"];

export function getAlarmSound() {
  return localStorage.getItem("gt_alarm_sound") || "chime";
}
export function setAlarmSound(s) {
  localStorage.setItem("gt_alarm_sound", s);
}

export function playAlarm(sound, repeats = 3) {
  const ac = getCtx();
  if (!ac) return;
  const cfg = SOUNDS[sound || getAlarmSound()] || SOUNDS.chime;
  let t = ac.currentTime;
  for (let r = 0; r < repeats; r++) {
    cfg.notes.forEach((freq, i) => {
      const osc = ac.createOscillator();
      const gain = ac.createGain();
      osc.type = cfg.type;
      osc.frequency.value = freq;
      const start = t + i * 0.18;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.45, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.16);
      osc.connect(gain).connect(ac.destination);
      osc.start(start);
      osc.stop(start + 0.18);
    });
    t += cfg.notes.length * 0.18 + 0.25;
  }
}

// Looping alarm that keeps ringing until the user stops it (or the safety timeout).
let loopTimer = null;
let safetyTimer = null;

export function startAlarmLoop(sound) {
  stopAlarm();
  const s = sound || getAlarmSound();
  playAlarm(s, 2);
  loopTimer = setInterval(() => playAlarm(s, 2), 2200);
  // Safety: auto-stop after 2 minutes so it never rings forever.
  safetyTimer = setTimeout(stopAlarm, 120000);
}

export function stopAlarm() {
  if (loopTimer) { clearInterval(loopTimer); loopTimer = null; }
  if (safetyTimer) { clearTimeout(safetyTimer); safetyTimer = null; }
}

